import procedurePricingReducer from './ProcedurePricingReducer';
import messageTrackingReducer from './MessageTrackingReducer';
import storeSettingReducer from './storeSettingReducer';
import storeContactReducer from './StoreContactReducer'
import visionWebReducer from './visionWebReducer';
import connectDevicesReducer from './connectDevicesReducer';
import promotionReducer from './promotionReducer';

const storeSettingsReducers ={
  procedurePricing: procedurePricingReducer,
  messageTracking: messageTrackingReducer,
  storeSetting: storeSettingReducer,
  storeContactSetting: storeContactReducer,
  visionWeb: visionWebReducer,
  connectDevices: connectDevicesReducer,
  storePromotion: promotionReducer,
};

export default storeSettingsReducers;
